import { Company } from '../data/cms';
import { useCms, CmsStatus, HtmlContent, safeLink } from './redesign/Cms';
import Reveal from './redesign/Reveal';

export function MapEmbed({ html, title }: { html?: string; title: string }) {
  if (!html) return null;
  const src = new DOMParser().parseFromString(html, 'text/html').querySelector('iframe')?.getAttribute('src');
  if (!src) return null;
  try {
    const url = new URL(src);
    if (url.protocol !== 'https:' || !['www.google.com', 'maps.google.com', 'www.google.co.jp', 'maps.google.co.jp'].includes(url.hostname) || !url.pathname.startsWith('/maps')) return null;
    return <iframe className="company-map" src={url.href} title={title} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />;
  } catch { return null; }
}
export default function CompanyInfoSection() {
  const { data: company, loading, error, retry } = useCms<Company>('/company-info');
  return <section className="cms-company-info" aria-label="会社概要"><Reveal><h2 className="content-heading" style={{ margin: '15px 0 30px' }}>会社概要</h2>
    {loading || error || !company ? <CmsStatus loading={loading} error={error} retry={retry} empty="会社情報は現在準備中です。" /> : <>
      <table className="detail-table"><tbody>
        {company.name && <tr><th scope="row">会社名</th><td>{company.name}</td></tr>}
        {company.establishment_date && <tr><th scope="row">設立</th><td>{company.establishment_date}</td></tr>}
        {company.address && <tr><th scope="row">本社</th><td>{company.postcode && <>〒{company.postcode}<br /></>}{company.address}{safeLink(company.map_url) && <div><a className="text-link" href={safeLink(company.map_url)} target="_blank" rel="noopener noreferrer">Googleマップで見る ↗</a></div>}</td></tr>}
        {company.address2 && <tr><th scope="row">支社</th><td>{company.postcode2 && <>〒{company.postcode2}<br /></>}{company.address2}{safeLink(company.map_url2) && <div><a className="text-link" href={safeLink(company.map_url2)} target="_blank" rel="noopener noreferrer">Googleマップで見る ↗</a></div>}</td></tr>}
        <tr><th scope="row">資本金</th><td>700万円（資本準備金含む）</td></tr>
        {company.business && <tr><th scope="row">事業内容</th><td><HtmlContent html={company.business} /></td></tr>}
      </tbody></table>
      <div className="company-maps">{company.googlemap_iframe && <div><h3>本社アクセス</h3><MapEmbed html={company.googlemap_iframe} title="本社の地図" /></div>}{company.googlemap_iframe2 && <div><h3>支社アクセス</h3><MapEmbed html={company.googlemap_iframe2} title="支社の地図" /></div>}</div>
    </>}
  </Reveal></section>;
}
